export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: "I look after three buildings on my own and the backlog was running me instead of the other way round. The work-order templates and the priority classification were the turning point. I now walk in, check the open list, and know what gets touched first. Two air handlers that used to fail every summer have been clean for a full season because the PM routine finally gets done.",
    author: 'Gary Holloway',
    role: 'Facilities Maintenance Technician, 47',
    location: 'Leeds, United Kingdom',
  },
  {
    text: "We had four technicians and four different ways of writing up a job. I printed the inspection checklists and the handover kit and made them standard on every shift. The difference showed up within a month: fewer repeat calls, and the night crew finally knows what the day crew left open. The 30-day reset plan is what I used to get us there.",
    author: 'Doug Ferrier',
    role: 'Maintenance Supervisor, Manufacturing Plant, 53',
    location: 'Hamilton, Canada',
  },
  {
    text: "Troubleshooting was always the part I improvised. Abnormal noise on a pump, and I'd start pulling things apart hoping to find it. The symptom-to-check reference stopped that. Last month I traced a vibration complaint to a loose base bolt in fifteen minutes instead of half a shift. That one guide has paid for the whole system several times.",
    author: 'Ray Sandoval',
    role: 'Industrial Maintenance Technician, 41',
    location: 'Columbus, United States',
  },
  {
    text: "Property maintenance means you never know what the day brings. What I needed wasn't more theory, it was paperwork that already exists. The work orders, the asset records and the parts inventory sheets went straight into use. I can now tell an owner exactly what was serviced, when, and what it cost, without digging through my phone.",
    author: 'Trevor Blackwood',
    role: 'Property Maintenance Contractor, 38',
    location: 'Brisbane, Australia',
  },
  {
    text: "I'm the only maintenance person for a school site and preventive work always lost to whatever broke that morning. The daily, weekly and monthly routines gave me a schedule I can actually keep, and the asset records mean I stop rediscovering the same faults. Emergency callouts are down noticeably since I started working the system properly.",
    author: 'Ian Prescott',
    role: 'Building Maintenance Officer, 56',
    location: 'Glasgow, United Kingdom',
  },
]
